import { render } from "./ChangeProfile.vue?vue&type=template&id=01300e22&scoped=true"
import script from "./ChangeProfile.vue?vue&type=script&lang=js"
export * from "./ChangeProfile.vue?vue&type=script&lang=js"

import "./ChangeProfile.vue?vue&type=style&index=0&id=01300e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01300e22"]])

export default __exports__